import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const ContentBody = styled.div`
    color: ${colors.greyscale.dark_grey};
    font-size: 16px;

    .card-detail{
        border: 1px solid #DDDDDD;
        border-radius: 16px;
        height: 100%;
    }
`